import { Helmet } from "react-helmet-async";

const BASE_URL = "https://upbrief.app";
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image.jpg`;

interface PageSeoProps {
  title: string;
  description: string;
  path: string;
  image?: string;
}

export const PageSeo = ({ title, description, path, image = DEFAULT_OG_IMAGE }: PageSeoProps) => {
  const url = `${BASE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};